import store from "../../src/store/store";
export default Vue => {
  //按钮权限控制
  //v-auth="'api'"
  //api是需要调用的api地址
  Vue.directive("auth", {
    bind(el, bind) {
      //权限列表
      let authList = store.state.authList;
      //判断是否存在于权限列表中
      if (!authList.some(item => item.url == bind.value)) {
        el.style.display = "none";
      } else {
        // el.style.display = "inline";
      }
    }
  });
};



// WEBPACK FOOTER //
// ./static/js/permission.js